import { Collapse } from 'bootstrap';
import SmoothScroll from 'smooth-scroll';

(function ($, root, undefined) {
	
	$(function () {
		
		'use strict';
		console.log('ready');

		var scroll = new SmoothScroll('a[href*="#"]', {
			topOnEmptyHash: true,
			speed: 500,
			speedAsDuration: true,
			offset: 78,
			easing: 'easeInOutQuad',
		});

	});
	
})(jQuery, this);

document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll('.header .menu .menu-item-has-children').forEach(function (item) {
		if (item.querySelector('.submenu-toggle')) return;

		const toggleButton = document.createElement('button');
		toggleButton.classList.add('submenu-toggle');
		toggleButton.setAttribute('aria-label', 'Rozwiń podmenu');
		toggleButton.setAttribute('aria-expanded', 'false');
		item.appendChild(toggleButton);

		toggleButton.addEventListener('click', function (event) {
			event.preventDefault();
			event.stopPropagation();
			const submenu = item.querySelector('.sub-menu');
			if (!submenu) return;
			const open = submenu.classList.toggle('is-open');
			toggleButton.classList.toggle('is-open', open);
			toggleButton.setAttribute('aria-expanded', open ? 'true' : 'false');
		});
	});
});

document.addEventListener("DOMContentLoaded", function() {
	const userAgent = navigator.userAgent || navigator.vendor || window.opera;
	const downloadBtn = document.getElementById("download-btn");

	if (downloadBtn) {
		if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
			downloadBtn.href = "https://apps.apple.com/pl/app/tellonym-ask-me-anything/id1265133033?l=pl";
		}
		else if (/Macintosh|MacIntel|MacPPC|Mac68K/.test(userAgent)) {
			downloadBtn.href = "https://apps.apple.com/pl/app/tellonym-ask-me-anything/id1265133033?l=pl";
		}
		else if (/android/i.test(userAgent)) {
			downloadBtn.href = "https://play.google.com/store/apps/details?id=de.tellonym.app";
		}
		else {
			downloadBtn.href = "https://play.google.com/store/apps/details?id=de.tellonym.app";
		}
	}
});